/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { arrays_equal, elementHasClassName, elementHasOneOfClassNames } from './util.js';
import { getFromSession, setInSession } from './session-util.js';
import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
import { mjt } from './i18ntexts.js';

import { closeAllTooltips } from './page-tooltips.js';

import { MPlugins } from './plugins.js';

import { unserializeSearchRequest, createSearchRequest } from './search-request.js';

import { MVPageHistory } from './page-history.js';
import { MVCollections } from './collections.js';
import { MVCompare } from './compare.js';
import { MVDetail } from './detail.js';
import { Lightbox } from './lightbox.js';
import { MVSearch } from './search.js';
import { MVTrees } from './trees.js';
import { MVResult } from './result.js';
import { MVPreview } from './preview.js';
import { MVDownload } from './download.js';
import { MVSend } from './send.js';
import { MVPublish } from './publish.js';
import { MVPrint } from './print.js';
import { MVExport } from './export.js';
import { MVBulkPermissions } from './bulk-perms.js';
import { MVSortOptions } from './sort-options.js';
import { MMediaViewsKbdCtrl } from './media-kbd-nav.js';

import { initMVMediaPageActions, delete_media, maintenance_post_import_media, maintenance_update_media, maintenance_re_import_media } from './media-page-actions.js';
import { MDTrees } from './tree-data.js';



export let MVMediaPage = function($,mj) {

	var m_has_dom = false;				// true, if there is a real DOM for the media page (false means: it is not available at all, so most functions will fail then)

	var m_sel_res_media_ids = [];
	var m_sel_lbo_media_ids = [];

	var m_sel_media_ids = [];

	var m_sel_editable_count = 0;
	var m_sel_deleteable_count = 0;
	var m_sel_downloadable_count = 0;
	var m_elem_media_lightbox_small = null;

	var m_lightbox_enabled = true;

	var m_elem_media_result = null;
	var m_elem_media_result0 = null;
	var m_scroll_borders = { top:0, btm:0 };

	var m_runOnceOnResultNodesLoaded = null;

	let m_mediaCtxMenuWasVisibleOnInteractionStart = false;
	let m_mediaCtxMenuSelectedMediaIdsOnInteractionStart = [];

	var m_media_ctx_menu_options = {
		reset: false,
		dynamic: null,
		cur_menu_handle: null,
		appendTo: '#page',
		templateElementId: 'media-ctx-menu-for-result-view',
		cssClassName: 'media-ctx-menu',
		bindings: {
			// === media actions ===
			// any role
			'media-ctxm-open':				function() {
				media_action('open');
			},
			'media-ctxm-open-all':			function(t) {
				if( elementHasClassName(t,'media') ) {
					MVResult.actionOnWholeResult( function(media_ids) {
						MVDetail.open(media_ids,'detail',0);
					} );
				} else {
					Lightbox.open(0);
				}
			},
			'media-ctxm-comments':			function() {
				media_action('annotations');
			},
			'media-ctxm-lb-in':				function() {
				media_action('lb-in');
			},
			'media-ctxm-lb-out':			function() {
				media_action('lb-out');
			},
			'media-ctxm-lb-other':			function() {
				media_action('lb-other');
			},
			'media-ctxm-download':			function() {
				media_action('download');
			},
			'media-ctxm-print':				function() {
				media_action('print');
			},
			'media-ctxm-compare':			function() {
				media_action('compare');
			},
			// user role
			'media-ctxm-send':				function() {
				media_action('send');
			},
			// manager role
			'media-ctxm-publish':			function() {
				media_action('publish');
			},
			'media-ctxm-link':				function() {
				media_action('link');
			},
			'media-ctxm-export':			function() {
				media_action('export');
			},
			'media-ctxm-delete':			function() {
				media_action('delete');
			},
			// administrator role
			'media-ctxm-acl':				function() {
				media_action('acl');
			},
			'media-ctxm-bulk-perms':		function() {
				media_action('bulk-perms');
			},
			'media-ctxm-post-import':		function() {
				media_action('post-import');
			},
			'media-ctxm-update':			function() {
				media_action('update');
			},
			'media-ctxm-re-import':			function() {
				media_action('re-import');
			},
			'media-ctxm-search-log':		function(t) {
				media_action('search-log');
			},

			// === category actions ===
			'media-ctxm-cat-open':			function(t) {
				MVTrees.execCategoryMenuAction('open',t,'category');
			},
			// manager or administrator role
			'media-ctxm-cat-edit':			function(t) {
				MVTrees.execCategoryMenuAction('edit',t,'category');
			},
			'media-ctxm-cat-sort':			function(t) {
				MVTrees.execCategoryMenuAction('sort',t,'category');
			},
			'media-ctxm-cat-sort-contents':	function(t) {
				MVTrees.execCategoryMenuAction('sort-contents',t,'category');
			},
			'media-ctxm-cat-move':			function(t) {
				MVTrees.execCategoryMenuAction('move',t,'category');
			},
			'media-ctxm-cat-add':			function(t) {
				MVTrees.execCategoryMenuAction('add',t,'category');
			},
			'media-ctxm-cat-delete':		function(t) {
				MVTrees.execCategoryMenuAction('delete',t,'category');
			},

			// administrator role
			'media-ctxm-cat-acl':	function(t) {
				MVTrees.execCategoryMenuAction('acl',t,'category');
			},
			'media-ctxm-cat-search-log':	function(t) {
				MVTrees.execCategoryMenuAction('search-log',t,'category');
			},
		},

		requireForwardedContextmenuEvent: function( evt, menu ) {
			var target = $(evt.target);
			var cat_node = target.closest('span.ui-dynatree-document');
			if( cat_node.length!==0 ) {
				// contextmenu on a category node ..
				return false;
			}
			// contextmenu on asset ...
			return true;
		},

		onContextMenu: function( evt, menu ) {
			var target = $(evt.target);
			var root = target.closest('#page-right div.media-view-container');
			const rootId = root.attr('id');

			const isForwardedEvent = evt.isForwardedEvent ?? false;
			// const triggeredBy = evt.triggeredBy ?? '';
			const triggeredByEvtType = evt.triggeredByEvtType ?? '';			// selectablestop or mouseup
			const triggeredByEvtWhich = evt.triggeredByEvtWhich ?? 1;
			// const triggeredByEvtCtrlKey = evt.triggeredByEvtCtrlKey ?? false;

			const isRealContextMenuEvent = evt.type==='contextmenu' && ( isForwardedEvent ? ( evt.isRealContextMenuEvent ?? true ) : true );

			let isCtxMenuTrigger = ( evt.type==='contextmenu' ) || ( evt.type==='mousedown' && evt.which===3 );
			if( isCtxMenuTrigger && evt.type==='contextmenu' && triggeredByEvtType==='mouseup' && triggeredByEvtWhich!==3 ) {
				isCtxMenuTrigger = false;
			}

			// console.log({
			// 	w: 'onContextMenu',
			// 	rootId,
			// 	// m_mediaCtxMenuWasVisibleOnInteractionStart,
			// 	evtMediaCtxMenuWasVisibleOnInteractionStart: evt.mediaCtxMenuWasVisibleOnInteractionStart ?? false,
			//	evtMediaCtxMenuSelectedMediaIdsOnInteractionStart: evt.mediaCtxMenuSelectedMediaIdsOnInteractionStart ?? [],
			// 	evtType: evt.type,
			// 	evtIsRealContextMenuEvent: isRealContextMenuEvent,
			// 	evtIsForwardedEvent: isForwardedEvent,
			// 	triggeredByEvtType,
			// 	triggeredByEvtWhich,
			// 	triggeredByEvtCtrlKey,
			// 	isCtxMenuTrigger,
			// 	target,
			// 	evt,
			// });


			let bShowContextMenu = true;
			if( root.length > 0 ) {
				bShowContextMenu = false;

				// .. in media result view ..
				var is_category = false;
				switch( rootId ) {
				case 'media-result':
					var thumbnail = target.hasClass('thumbnail') ? target : target.find('.thumbnail');
					if( thumbnail.length === 0 ) thumbnail = target.closest('.media',root[0]).find('.thumbnail');
					if( thumbnail.length > 0 ) {
						// media items
					} else {
						thumbnail = target.hasClass('cthumbnail') ? target : target.find('.cthumbnail');
						if( thumbnail.length === 0 ) thumbnail = target.closest('.category',root[0]).find('.cthumbnail');
						if( thumbnail.length > 0 ) {
							// category items
							is_category = true;
						}
					}
					if( isCtxMenuTrigger && !thumbnail.hasClass('ui-selected') ) {
						// select single thumbnail
						root.find('.thumbnail.ui-selected,.cthumbnail.ui-selected').removeClass('ui-selected');
						thumbnail.not('.ui-selected').addClass('ui-selected');

						if( m_lightbox_enabled && ( is_category || !( evt.ctrlKey || evt.altKey ) ) ) {
							$('#lb-result > div.lb-item.ui-selected').removeClass('ui-selected');
						}
						MVResult.selectionChanged(evt,'m_media_ctx_menu_options -> onContextMenu(media-result)');
					}
					break;
				case 'media-lightbox-small-inner':
					var root2 = root.children('#lb-result');
					var item = target.hasClass('lb-item') ? target : target.closest('.lb-item',root2[0]);
					if( isCtxMenuTrigger && !item.hasClass('ui-selected') ) {
						// select single thumbnail
						root2.children('.lb-item.ui-selected').removeClass('ui-selected');
						item.not('.ui-selected').addClass('ui-selected');

						if( !( evt.ctrlKey || evt.altKey ) ) {
							$('#media-result .thumbnail.ui-selected').removeClass('ui-selected');
						}
						$('#media-result .cthumbnail.ui-selected').removeClass('ui-selected');
						Lightbox.selectionChanged(evt,'m_media_ctx_menu_options -> onContextMenu(media-lightbox-small-inner)');
					}
					break;
				}

				if( is_category ) {
					bShowContextMenu = isRealContextMenuEvent || isCtxMenuTrigger;
				} else {
					bShowContextMenu =
						( $('.ui-selected',m_elem_media_result).length > 0 )
						||
						( m_lightbox_enabled && $('.ui-selected',m_elem_media_lightbox_small).length > 0 )
					;
					// ( root.find('.thumbnail.ui-selected,.cthumbnail.ui-selected').length > 0 )
					// ||
					// ( root.children('#lb-result').children('.lb-item.ui-selected').length > 0 );
				}
			}


			if( bShowContextMenu ) {
				// special case.. when:

				// - it was not explicitly opened (ie by RIGHt click):
				if( !isCtxMenuTrigger ) {

					// - menu was visible before:
					if( evt.mediaCtxMenuWasVisibleOnInteractionStart ?? false ) {

						// - and actual selection did not actually change:
						const selectionDidNotChangeSinceInteractionStart = arrays_equal( evt.mediaCtxMenuSelectedMediaIdsOnInteractionStart, m_sel_media_ids );
						if( selectionDidNotChangeSinceInteractionStart ) {

							// then dont show menu:
							bShowContextMenu = false;

						}
					}
				}
			}


			return bShowContextMenu;
		},

		onShowMenu: function( evt, menu, calledFrom ) {
			var target = $(evt.target);
			var root = target.closest('#page-right div.media-view-container');

			if( root.length > 0 ) {
				const rootId = root.attr('id');

				// .. in media result view ..
				switch( rootId ) {
				case 'media-result':
					var thumbnail = target.hasClass('thumbnail') ? target : target.find('.thumbnail');
					if( thumbnail.length === 0 ) thumbnail = target.closest('.media',root[0]).find('.thumbnail');
					var is_category = false;
					if( thumbnail.length > 0 ) {
						// media items
					} else {
						thumbnail = target.hasClass('cthumbnail') ? target : target.find('.cthumbnail');
						if( thumbnail.length === 0 ) thumbnail = target.closest('.category',root[0]).find('.cthumbnail');
						if( thumbnail.length > 0 ) {
							// category items
							is_category = true;
						}
					}
					if( m_lightbox_enabled ) {
						const resultListType = MVResult.getWidget().getWrappedListType();
						if( resultListType != "lightbox" ) {
							$('#media-ctxm-lb-out',menu).remove();
						} else {
							$('#media-ctxm-lb-in',menu).remove();
						}
					} else {
						$('#media-ctxm-lb-in,#media-ctxm-lb-out',menu).remove();
					}

					if( !is_category ) {
						if( MVSearch.getResultInfo().work_count > 1000 ) {
							$('#media-ctxm-open-all',menu).remove(); // zu viele ids, um alle zu oeffnen (wegen timeouts)
						}
					}
					break;
				case 'media-lightbox-small-inner':
					$('#media-ctxm-lb-in',menu).remove();
					break;
				}

				if( !m_lightbox_enabled || !Lightbox.isEditable() ) {
					$('#media-ctxm-lb-in,#media-ctxm-lb-out',menu).remove();
				}


				if( (mj.media_page_embed_mode??false)!==false ) {

					// remove some actions from menus:
					$('#media-ctxm-link,#media-ctxm-send,#media-ctxm-export,#media-ctxm-publish,#media-ctxm-delete,#media-ctxm-print',menu).remove();
					$('#media-ctxm-cat-edit,#media-ctxm-cat-sort,#media-ctxm-cat-sort-contents,#media-ctxm-cat-move,#media-ctxm-cat-add,#media-ctxm-cat-delete,#media-ctxm-cat-acl,#media-ctxm-cat-search-log',menu).remove();

				}

				var sel_cat_ids = MVTrees.getSelectionOfCategoryTreeUI('category');
				if( sel_cat_ids.length===0 ) {
					// media items
					if( m_sel_deleteable_count===0 ) $('#media-ctxm-delete',menu).remove();
					if( m_sel_downloadable_count===0 ) $('#media-ctxm-download',menu).remove();
					if( m_sel_media_ids.length > 1 ) $('#media-ctxm-open-all',menu).remove(); // 'alle oeffnen' ausblenden, es ist in diesem fall missverstaendlich...
					if( m_sel_media_ids.length===0 || m_sel_media_ids.length>2 ) $('#media-ctxm-compare',menu).remove(); // must have exactly 1 or 2 items to start compare dialog
					if( m_sel_media_ids.length===0 || m_sel_media_ids.length>1 ) $('#media-ctxm-search-log',menu).remove(); // must have exactly 1 item
					$('#media-ctxm-cat-open,#media-ctxm-cat-edit,#media-ctxm-cat-sort,#media-ctxm-cat-sort-contents,#media-ctxm-cat-move,#media-ctxm-cat-add,#media-ctxm-cat-delete,#media-ctxm-cat-administration,#media-ctxm-cat-acl,#media-ctxm-cat-search-log',menu).remove();
					if(MPlugins.isRegistered('ui-collabannot-thumb-view')) {
						if(m_sel_media_ids.length === 1) {
							let annotations = 0;
							m_sel_media_ids.forEach(function(id) {
								let status = MPlugins.getByName('ui-collabannot-thumb-view').getStatusItem(id);
								annotations += parseInt(status ? status.actual_annots_count ?? 0 : 0);
							});
							let text = annotations === 0 ? mjt('ctx-menu-comments-0') : (annotations === 1 ? mjt('ctx-menu-comments-1') : mjt('ctx-menu-comments-x').replace('%1', annotations));
							$('#media-ctxm-comments .text', menu).text(text);
						} else {
							$('#media-ctxm-comments .text', menu).text(mjt('ctx-menu-comments'));
						}
					} else {
						$('#media-ctxm-comments', menu).remove();
					}
					if( m_sel_media_ids.length > 1 ) {
						$('#media-ctxm-open b', menu).text(mjt('ctx-menu-open-x').replace('%1', m_sel_media_ids.length));
					} else {
						$('#media-ctxm-open b', menu).text(mjt('ctx-menu-open'));
					}
				} else {
					// category item(s)
					MVTrees.prepareContextMenuForDisplay( menu, sel_cat_ids[0][0], sel_cat_ids[0][1], 'media-ctxm-cat-', 'category' );
					focus_category_for_ctx_menu( sel_cat_ids[0][0], sel_cat_ids[0][1] );
				}
				// disable text selection on menu layer
				menu[0].ondrag = function() {
					return false;
				};
				menu[0].ondragstart = function() {
					return false;
				};
				menu[0].onselectstart = function() {
					return false;
				};

				return menu;
			}

			// .. not in media result view ..
			return MVTrees.onShowContextMenu(evt,menu,'category',focus_category_for_ctx_menu);
		},
		onHideMenu: function( menu ) {
			if( menu.is(':visible') ) {
				// unset focus only if menu was really hidden actually (avoiding multiple hide events here..)
				focus_category_for_ctx_menu(null,null);
				// m_media_ctx_menu_options.requireForwardedContextmenuEvent = false;
				m_media_ctx_menu_options.cur_menu_handle = null;
			}
		},
	};

	// "context toolbar" uses the same callbacks as the "context menu"
	var media_ctx_toolbar_options = {
		bindings: {},
		appendTo: '#page',
	};
	$.each( m_media_ctx_menu_options.bindings, function(id,cb) {

		var id2 = id.substr(0,9)+'tb'+id.substr(10);
		if( !(id2 in media_ctx_toolbar_options.bindings) ) media_ctx_toolbar_options.bindings[id2] = cb;
	} );

	function focus_category_for_ctx_menu( tree_id, cat_id ) {
		// reset: category filter
		$('#media-cat-trees .ui-dynatree-focused').removeClass('ui-dynatree-focused');
		// reset: result view
		$('.ui-focused.category',m_elem_media_result0).removeClass('ui-focused');
		if( tree_id!==null && cat_id!==null ) {
			// set focused state on category node in filter tree ...
			var catNode = $('#cat-node-'+tree_id+'-'+cat_id);
			catNode.not('.ui-dynatree-focused').addClass('ui-dynatree-focused');
			catNode.focus();
			// set focused state on category node in result view ...
			$('.category',m_elem_media_result0).filter('[mj_tree_id='+tree_id+'][mj_cat_id='+cat_id+']').not('.ui-focused').addClass('ui-focused');
		}
	}

	function start_search( data, meta_id ) {
		if( !m_has_dom ) return;
		MVCompare.hide();
		MVDetail.hide();
		MVSearch.triggerSearchByMeta( data, meta_id );
		// TODO: use MVPageHistory.go() -- but only after detail view got its own hashchange key
		//MVPageHistory.go('search_meta',[meta_id,data]);
	}

	function start_search_categories( tree_id, cat_id ) {
		if( !m_has_dom ) return;
		MVCompare.hide();
		MVDetail.hide();
		MVPageHistory.go('category',[tree_id,cat_id]);
	}

	function search_log_media( media_ids ) {
		var url = mj.uwn+'/administration/logs#entity=1:'+media_ids[0];
		window.open(url,'_blank');
	}

	function selection_changed( evt, opt_open_whole_list_cb, calledFrom ) {

		// get selection, plus some additional info about it (TODO: refactor into own function) ...
		var l_lbo_media_ids=[];
		var l_res_media_ids=[];
		var l_media_ids=[];

		var l_editable_count=0;
		var l_deleteable_count=0;
		var l_downloadable_count=0;

		var l_category_ids=[];
		var l_mids_hash = {}; // used to exclude simultanous selection of same media_id in lightbox and result

		var lbr0, nodes, nodes_len, i, edat, m, cnodes, cnodes_len, cnode, tb0,en,enm,c_en;

		const lightbox_visible = m_lightbox_enabled && ( m_elem_media_lightbox_small!==null && m_elem_media_lightbox_small.css('display')!=='none' );

		if( (mj.media_page_embed_mode??false)==='single' ) {
			// single selection mode:
			let tmpSelectedNodes = $([]);
			if( lightbox_visible ) tmpSelectedNodes = m_elem_media_lightbox_small.find('.smn.ui-selected');
			let tmp2 = m_elem_media_result.find('.smn.ui-selected');
			$.merge(tmpSelectedNodes,tmp2);
			if( tmpSelectedNodes.length > 1 ) {
				const refX = evt.pageX ?? evt.originalEvent.pageX ?? 0;
				const refY = evt.pageY ?? evt.originalEvent.pageY ?? 0;
				let bestMatchElem = null;
				if( refX===0 && refY===0 ) {
					// mouse pos unknown -> probably selection by keyboard,
					// try to select the node, that was selected latest
					let maxSelCnt = -1;
					tmpSelectedNodes.each( function() {
						const $node = $(this);
						const selCnt = $node.data('selCnt') ?? 0;
						// const $item = $node.hasClass('lb-item') ? $node : $node.closest('.item');
						// const itemTidx = $item.attr('mj_tidx');
						// console.log({ selCnt, itemTidx });
						if( selCnt > maxSelCnt ) {
							maxSelCnt = selCnt;
							bestMatchElem = this;
						}
					} );
				} else {
					// select the node nearest to mouse pos
					let minDist = Number.MAX_VALUE;
					tmpSelectedNodes.each( function() {
						const bcr = this.getBoundingClientRect();
						const midX = bcr.left + 0.5 * bcr.width;
						const midY = bcr.top + 0.5 * bcr.height;
						const distSq = (midX-refX)*(midX-refX) + (midY-refY)*(midY-refY);
						if( distSq < minDist ) {
							minDist = distSq;
							bestMatchElem = this;
						}
					} );
				}
				if( bestMatchElem!==null ) {
					tmpSelectedNodes.not(bestMatchElem).removeClass('ui-selected');
				}
			}
		}



		if( lightbox_visible ) {
			lbr0=document.getElementById('lb-result');
			nodes=$('.ui-selected.undel',lbr0);
			nodes_len=nodes.length;
			for( i=0; i<nodes_len; ++i ) {
				edat = $.data(nodes[i]);
				m = edat.media_id;
				if( !m ) {
					// found a hole in selection list -> just skip this item
					continue;
				}
				l_mids_hash[m] = 1;
				l_lbo_media_ids.push(m);
				l_media_ids.push(m);
				if( edat.r_edt ) l_editable_count ++;
				if( edat.r_del ) l_deleteable_count ++;
				if( edat.r_dwn ) l_downloadable_count ++;
			}
		}

		var tmp_sel_nodes = m_elem_media_result===null ? [] : m_elem_media_result.find('.ui-selected');

		nodes = tmp_sel_nodes.filter('.thumbnail').closest('div.media').filter('.undel');
		nodes_len = nodes.length;
		for( i=0; i<nodes_len; ++i ) {
			edat = $.data(nodes[i]);
			m = edat.media_id;
			if( !m ) {
				// found a hole in selection list -> just skip this item
				continue;
			}
			if( !(m in l_mids_hash) ) {
				l_res_media_ids.push(m);
				l_media_ids.push(m);
				if( edat.r_edt ) l_editable_count ++;
				if( edat.r_del ) l_deleteable_count ++;
				if( edat.r_dwn ) l_downloadable_count ++;
			}
		}

		cnodes = tmp_sel_nodes.filter('.cthumbnail').closest('div.category');
		cnodes_len = cnodes.length;
		for( i=0; i<cnodes_len; ++i ) {
			cnode=$(cnodes[i]);
			l_category_ids.push([cnode.attr('mj_tree_id'),cnode.attr('mj_cat_id')]);
		}

		var sel_actually_changed = l_editable_count!==m_sel_editable_count;
		sel_actually_changed = sel_actually_changed || l_deleteable_count!==m_sel_deleteable_count;
		sel_actually_changed = sel_actually_changed || l_downloadable_count!==m_sel_downloadable_count;
		sel_actually_changed = sel_actually_changed || !arrays_equal(l_lbo_media_ids,m_sel_lbo_media_ids);
		sel_actually_changed = sel_actually_changed || !arrays_equal(l_res_media_ids,m_sel_res_media_ids);
		sel_actually_changed = sel_actually_changed || !arrays_equal(l_category_ids,MVTrees.getSelectionOfCategoryTreeUI('category'));

		// if context toolbar preparation required or if selection actually changed
		// drag event for selected items

		if( sel_actually_changed ) {
			closeAllTooltips();
			// remember new selection
			m_sel_editable_count = l_editable_count;
			m_sel_deleteable_count = l_deleteable_count;
			m_sel_downloadable_count = l_downloadable_count;
			m_sel_lbo_media_ids = l_lbo_media_ids;
			m_sel_res_media_ids = l_res_media_ids;
			m_sel_media_ids = l_media_ids;
			MVTrees.setSelectionOfCategoryTreeUI('category',l_category_ids);

			// update states
			tb0 = document.getElementById('media-toolbar');
			en = m_sel_media_ids.length>0;
			enm = m_sel_res_media_ids.length>0;
			var sel_cat_ids = MVTrees.getSelectionOfCategoryTreeUI('category');
			c_en = sel_cat_ids.length>0;

			// toolbar states
			$('#tb-selected,#tb-open-i,#tb-open-t,#tb-edit-i,#tb-edit-t,#tb-send-i,#tb-send-t,#tb-publish-i,#tb-publish-t,#tb-export-i,#tb-export-t,#tb-print-i,#tb-print-t',tb0).toggleClass('disabled',!en);
			$('#tb-download-i,#tb-download-t',tb0).toggleClass('disabled',m_sel_downloadable_count===0);
			$('#tb-delete-i,#tb-delete-t',tb0).toggleClass('disabled',m_sel_deleteable_count===0);

			if( m_lightbox_enabled ) {
				const resultListType = MVResult.getWidget().getWrappedListType();
				$('#tb-lbin-i,#tb-lbin-t',tb0).toggle(resultListType !== "lightbox").toggleClass('disabled',!enm);
				$('#tb-lbout-i,#tb-lbout-t',tb0).toggle(resultListType === "lightbox").toggleClass('disabled',!en);
			} else {
				$('#tb-lbin-i,#tb-lbin-t',tb0).hide();
				$('#tb-lbout-i,#tb-lbout-t',tb0).hide();
			}

			if( c_en ) $('#tb-selected,#tb-open-i,#tb-open-t,#tb-edit-i,#tb-edit-t').filter('.disabled').removeClass('disabled');

			if( opt_open_whole_list_cb===null && m_sel_media_ids.length>1 ) {
				// set callback to open whole list ...
				if( m_sel_lbo_media_ids.length>0 && m_sel_res_media_ids.length===0 ) opt_open_whole_list_cb = Lightbox.openWholeResultInDetailView;
				else if( m_sel_res_media_ids.length>0 && m_sel_lbo_media_ids.length===0 ) opt_open_whole_list_cb = MVResult.openWholeResultInDetailView;
			}
			MVPreview.onSelectionChanged(m_sel_media_ids,opt_open_whole_list_cb);
			m_elem_media_result.find('.ui-draggable').removeClass('drag-media').draggable('destroy');
			tmp_sel_nodes.closest('.item').addClass('drag-media').draggable( {
				opacity: 0.8,
				appendTo: 'body',
				distance: 5,
				zIndex: 502,
				scroll: false,
				cursor: 'move',
				cursorAt: { top:16, left:12 },
				//refreshPositions: true,
				helper: function() {
					var helper = $('<div id="media-drag-helper"><span class="drag-info"></span><span class="drop-info"></span></div>')
						.children('.drag-info')
						.text( m_sel_media_ids.length===1 ? mjt('media-drag-info-1') : mjt('media-drag-info').replace('%d',m_sel_media_ids.length) )
						.end()
									;
					return helper[0];
				},
				start: function( evt, ui ) {
					$(this).data('drag_media_ids',m_sel_media_ids);
					if( m_lightbox_enabled ) Lightbox.activateDropTargets(true,evt,ui);
					MVSearch.activateDropTargets(true,evt,ui);
					return true;
				},
				stop: function( evt, ui ) {
					// deactivate drop targets
					if( m_lightbox_enabled ) Lightbox.activateDropTargets(false,evt,ui);
					MVSearch.activateDropTargets(false,evt,ui);
				}
			} );

		}
		MPlugins.callOnAllPluginsOfType('MediaResultView','selectionChanged',true,sel_actually_changed,m_sel_media_ids);
	}

	function media_action( action ) {
		if( m_sel_media_ids.length ) {
			switch( action ) {
			// any role
			case 'open':
				MVDetail.open(m_sel_media_ids,'detail',0,m_sel_lbo_media_ids.length?Lightbox.openWholeResultInDetailView:MVResult.openWholeResultInDetailView);
				break;

			case 'annotations':
				MVDetail.open(m_sel_media_ids,'annotations',0,m_sel_lbo_media_ids.length?Lightbox.openWholeResultInDetailView:MVResult.openWholeResultInDetailView);
				break;

			case 'lb-in':
				if( m_sel_res_media_ids.length && MVResult.getWidget().getWrappedListType() !== "lightbox" ) {
					Lightbox.insert(m_sel_res_media_ids, -1, true);
				}
				break;
			case 'lb-out':
				if( MVResult.getWidget().getWrappedListType() === "lightbox" && m_sel_media_ids.length ) {
					Lightbox.remove(m_sel_media_ids,function() {
					});
				} else if( m_sel_lbo_media_ids.length ) {
					Lightbox.remove(m_sel_lbo_media_ids,function() {
						// TODO: do select prev/next node ???
					});
				}
				break;
			case 'lb-other':
				Lightbox.insertIntoOther(m_sel_media_ids);
				break;

			case 'download':	MVDownload.open(m_sel_media_ids);			break;
			case 'print':		MVPrint.open(m_sel_media_ids,'');			break;
			case 'compare':
				if( m_sel_media_ids.length===1 ) MVCompare.selectItem(m_sel_media_ids[0],null,true);
				else if( m_sel_media_ids.length>=2 ) MVCompare.startCompare(m_sel_media_ids[0],null,m_sel_media_ids[1],null,'auto');
				break;
			// user role
			case 'send':		MVSend.openMediaIDs(m_sel_media_ids);		break;
			case 'link':		MVSend.openMediaIDs(m_sel_media_ids, undefined, 'link');		break;
			// manager role
			case 'publish':		MVPublish.open(m_sel_media_ids);			break;
			case 'export':		MVExport.open(m_sel_media_ids);			break;
			case 'delete':
				delete_media(m_sel_media_ids);
				break;
			// administrator role
			case 'acl':
				MVDetail.open(m_sel_media_ids,'acl',0,m_sel_lbo_media_ids.length?Lightbox.openWholeResultInDetailView:MVResult.openWholeResultInDetailView);
				break;
			case 'bulk-perms':
				MVBulkPermissions.open(m_sel_media_ids);
				break;
			case 'post-import':
				maintenance_post_import_media(m_sel_media_ids);
				break;
			case 'update':
				maintenance_update_media(m_sel_media_ids);
				break;
			case 're-import':
				maintenance_re_import_media(m_sel_media_ids);
				break;
			case 'search-log':
				search_log_media(m_sel_media_ids);
				break;
			}
		} else if( MVTrees.getSelectionOfCategoryTreeUI('category').length ) {
			MVTrees.execCategoryMenuAction(action,null,'category');
		}
	}


	function disableLightbox() {
		m_lightbox_enabled = false;
		m_elem_media_lightbox_small.hide();
		$('#media-header-lightbox-1').hide();
	}


	function init() {
		//========================================================================================================
		// setup result view
		//========================================================================================================

		var pr = $('#page-right');
		var mr_info = $('#media-result-info');
		m_elem_media_result = $('#media-result');
		m_has_dom = m_elem_media_result.length>0;
		m_elem_media_result0 = m_elem_media_result[0];
		var mr_and_mr_info = mr_info.add(m_elem_media_result0);

		m_elem_media_lightbox_small = $('#media-lightbox-small');

		if( (mj.media_page_embed_mode??false)!==false ) {
			disableLightbox();
		}


		MVTrees.setupCategoryTreeUI(
			'category',
			'#cat-tree-',
			m_media_ctx_menu_options,
			{
				go_cb:						MVPageHistory.go,
				focus_cb:					focus_category_for_ctx_menu,
				onAfterTreeStructureChange:	MVSearch.refreshCategoryTree,
				onAfterTreeNodeCRUDAction: 	MVSearch.refreshCategoryTree2,
			}
		);

		m_elem_media_result
			.off('scroll')
			.on( 'scroll', $.debounce( 250, function() {
			} ) );

		// setup result info view
		mr_info.mjMediaResultInfoWidget();

		pr[0].ondrag = function() {
			return false;
		};
		pr[0].ondragstart = function() {
			return false;
		};
		pr.on('selectstart',function(e) {
			var t = $(e.target);
			if( t.hasClass('meta-id') || t.closest('.meta_container').length>0 || t.closest('#media-preview').length>0) {
				// allow selection ..
				return;
			}
			return false;
		});

		// TODO: refactoring required ...

		let m_timer_click_contextmenu_show = null;
		let m_last_selectable_mousedown_on_elem_to_ignore = null;


		const common_selectable_options = {
			cancel: '#media-header,#media-toolbar,div.more,#lb-toolbar,#lb-less,#lb-more,div.mmb,div.cmb,#media-preview-band,#media-preview,#media-result-info,.meta_container,.clickable-media-overlay',
			distance: 1,
			appendHelpersTo: '#page',
			outRange: true,
			start: function( evt, ui ) {
				// console.log({w:'common_selectable_options START',m_mediaCtxMenuWasVisibleOnInteractionStart});
				// console.log({w:'common_selectable_options START -> before altering .ui-selected', evt, uiMediaResultSelLen:$('.ui-selected',m_elem_media_result).length, uiLightboxSelLen:$('.ui-selected',m_elem_media_lightbox_small).length });
				// close ...
				closeAllTooltips();
				mr_info.mjMediaResultInfoWidget('closeOverlay');
				// remove focus from search string (for kbd nav...)
				MVSearch.looseFocus();
				if( !evt.ctrlKey && !evt.shiftKey ) {
					// console.log({w:'common_selectable_options START (!e.ctrlKey && !e.shiftKey)', evt, uiMediaResultSelLen:$('.ui-selected',m_elem_media_result).length, uiLightboxSelLen:$('.ui-selected',m_elem_media_lightbox_small).length });
					pr.find('.smn.ui-selected').removeClass('ui-selected');
				}
				// console.log({w:'common_selectable_options START -> after  altering .ui-selected', evt, uiMediaResultSelLen:$('.ui-selected',m_elem_media_result).length, uiLightboxSelLen:$('.ui-selected',m_elem_media_lightbox_small).length });
			},
			stop: function( evt, ui ) {
				// console.log({w:'common_selectable_options STOP',m_mediaCtxMenuWasVisibleOnInteractionStart});
				// console.log({w:'common_selectable_options STOP -> before selection_changed', evt, uiMediaResultSelLen:$('.ui-selected',m_elem_media_result).length, uiLightboxSelLen:$('.ui-selected',m_elem_media_lightbox_small).length });
				selection_changed(evt,true,'common_selectable_options STOP');
				// console.log({w:'common_selectable_options STOP -> after  selection_changed', evt, uiMediaResultSelLen:$('.ui-selected',m_elem_media_result).length, uiLightboxSelLen:$('.ui-selected',m_elem_media_lightbox_small).length });
				let newEvent = $.Event('contextmenu');
				newEvent.target = evt.target;
				newEvent.pageX = evt.pageX;
				newEvent.pageY = evt.pageY;
				newEvent.triggeredBy = 'common_selectable_options stop';
				newEvent.triggeredByEvtType = evt.type;
				newEvent.triggeredByEvtWhich = evt.which ?? 1;
				newEvent.triggeredByEvtCtrlKey = evt.ctrlKey ?? false;
				if( m_lightbox_enabled ) {
					m_elem_media_lightbox_small.trigger(newEvent);
				}
				m_elem_media_result.trigger(newEvent);
			},
		};

		var common_selectable_on_contextmenu_fn = function( e ) {
			const jt = $(e.target);

			// ignore right click on 'clickable-media-overlay' elements ...
			if( jt.hasClass('clickable-media-overlay') ) {
				return;
			}

			const isRealContextMenuEvent = !e.hasOwnProperty('triggeredBy');
			if( isRealContextMenuEvent ) {
				const textSelection = window.getSelection && window.getSelection();
				if( textSelection && textSelection.toString()!=='' ) {
					// -> continue with browsers context menu
					return true;
				}
			}

			const $closestMediaResult = jt.closest('#media-result');
			if( $closestMediaResult.length===0 && jt.closest('#media-lightbox-small').length===0 ) {
				// is neither in #media-result, nor in #media-lightbox-small
				// -> continue with browsers context menu
				return true;
			}

			let tn = jt.closest('.media,.category',m_elem_media_result0);
			if( tn.length===0 ) {
				// not on a "#media-result .media" ... -> check whether node is "#lb-result .lb-item"
				let lbr = null;
				if( m_lightbox_enabled ) {
					lbr = $('#lb-result');
					if( jt.hasClass('lb-item') ) tn = jt;
					else tn = jt.closest('.lb-item',lbr[0]);
				}
				if( tn.length===0 ) {
					// target is no media-node -> trigger media-context-menu if at least one result- or media-item is selected, else do nothing
					const mr_1stsel_thumb = m_elem_media_result.find('.thumbnail.ui-selected,.cthumbnail.ui-selected').first();
					if( mr_1stsel_thumb.length ) {
						e.target = mr_1stsel_thumb[0];
						tn = mr_1stsel_thumb.closest('.media,.category',m_elem_media_result0);
					} else if( m_lightbox_enabled && m_elem_media_lightbox_small.is(':visible') ) {
						const lb_1stsel_item = $('.lb-item.ui-selected',lbr[0]).first();
						if( lb_1stsel_item.length ) {
							e.target = lb_1stsel_item[0];
							tn = lb_1stsel_item;
						}
					}
				}
			}

			tn = tn.filter('.media.undel,.lb-item.undel,.category')	// filter "deleted media" nodes & category nodes
				.not('.up');										// filter "category up" nodes

			// console.log({w:'common_selectable_on_contextmenu_fn .. tn.length='+(tn.length??'unknown')});
			if( tn.length ) {
				if( !isRealContextMenuEvent ) {
					const tnSelected = tn.filter('.item-selected,.ui-selected,.category');
					if( tnSelected.length===0 ) {
						// console.log({w:'HERE',e,tn});
						if( tn.length===1 && (e.triggeredByEvtCtrlKey??false) ) {
							// skip -> .. this is far from perfect, but ok for now
						} else {
							return true;
						}
					}
				}

				const tn0 = tn[0];
				// lazy-install context menu on this node
				if( !$.data(tn0,'ctxm_bound') ) {
					$.data(tn0,'ctxm_bound',true);
					// m_media_ctx_menu_options.requireForwardedContextmenuEvent = true;
					m_media_ctx_menu_options.cur_menu_handle = tn.contextMenu('media-ctx-menu',m_media_ctx_menu_options);
				} else if(m_media_ctx_menu_options.reset) {
					m_media_ctx_menu_options.reset = false;
					// m_media_ctx_menu_options.requireForwardedContextmenuEvent = true;
					m_media_ctx_menu_options.cur_menu_handle = tn.contextMenu('media-ctx-menu',m_media_ctx_menu_options);
				}

				// call event handler directly
				e.isForwardedEvent = true;
				e.isRealContextMenuEvent = isRealContextMenuEvent;
				e.mediaCtxMenuWasVisibleOnInteractionStart = m_mediaCtxMenuWasVisibleOnInteractionStart;
				e.mediaCtxMenuSelectedMediaIdsOnInteractionStart = m_mediaCtxMenuSelectedMediaIdsOnInteractionStart.slice();
				$.event.dispatch.apply( tn0, arguments );
			}

			return false;
		}; // common_selectable_on_contextmenu_fn


		if( m_lightbox_enabled ) {
			m_elem_media_lightbox_small
				.selectable( Object.assign(
					{},
					common_selectable_options,
					{
						scrollEnabled: false,
						prepare: function( e, ui ) {
							var selectableItems = [];
							// lightbox view
							if( m_elem_media_lightbox_small.css('display')!=='none' ) {
								$('#lb-result').children('.lb-item.undel').each( function() {
									var nd = this;
									// pre-compute dimensions
									$.data(nd,'selectable-dimensions',Lightbox.getItemDimensions($(nd)));
									// and add node to result
									selectableItems.push(nd);
								} );
							}
							$(this).selectable('setSelectees',$(selectableItems));
						},
					}
				) )
				.on( 'contextmenu', common_selectable_on_contextmenu_fn )
				.on( 'mousedown', function(evt) {

					// ignore this when on a button ..
					if( evt.which == 1 && elementHasOneOfClassNames(evt.target,['mmb']) ) {
						m_last_selectable_mousedown_on_elem_to_ignore = evt.target;
						return;
					}

					m_mediaCtxMenuWasVisibleOnInteractionStart = $('#media-ctx-menu').css('display') === 'block';
					m_mediaCtxMenuSelectedMediaIdsOnInteractionStart = m_sel_media_ids.slice();
					// console.log({w:'m_elem_media_lightbox_small MOUSEDOWN ...', evt, evtWhich:evt.which, uiMediaResultSelLen:$('.ui-selected',m_elem_media_result).length, uiLightboxSelLen:$('.ui-selected',m_elem_media_lightbox_small).length });
					let target = $(evt.target);
					if( !target.hasClass('lb-item') && evt.which == 1 && !( evt.ctrlKey || evt.shiftKey )) {
						// click in between thumbnails. deselect all assets
						m_elem_media_lightbox_small.find('.ui-selected').removeClass('ui-selected');
						m_elem_media_result.find('.ui-selected').removeClass('ui-selected');
						selection_changed(evt,false,'m_elem_media_lightbox_small MOUSEDOWN');
					}
				})
				.on( 'mouseup', function(evt) {

					const tmp_elem = m_last_selectable_mousedown_on_elem_to_ignore;
					m_last_selectable_mousedown_on_elem_to_ignore = null;
					if( evt.which==1 && tmp_elem===evt.target ) {
						// ignore clicks on buttons ..
						return;
					}

					// console.log({w:'m_elem_media_lightbox_small MOUSEUP ...', evt, evtWhich:evt.which, uiMediaResultSelLen:$('.ui-selected',m_elem_media_result).length, uiLightboxSelLen:$('.ui-selected',m_elem_media_lightbox_small).length });
					if( m_timer_click_contextmenu_show ) {
						clearTimeout(m_timer_click_contextmenu_show);
					}
					m_timer_click_contextmenu_show = setTimeout(function() {
						let newEvent = $.Event('contextmenu');
						newEvent.target = evt.target;
						newEvent.pageX = evt.pageX;
						newEvent.pageY = evt.pageY;
						newEvent.triggeredBy = 'm_elem_media_lightbox_small mouseup';
						newEvent.triggeredByEvtType = evt.type;
						newEvent.triggeredByEvtWhich = evt.which ?? 1;
						newEvent.triggeredByEvtCtrlKey = evt.ctrlKey ?? false;
						if( m_lightbox_enabled ) {
							m_elem_media_lightbox_small.trigger(newEvent);
						}
						m_elem_media_result.trigger(newEvent);
					}, 250);
				})
				.on('dblclick', function(evt) {
					// console.log({w:'lightbox dblclick ...',evt});
					if( m_timer_click_contextmenu_show ) {
						clearTimeout(m_timer_click_contextmenu_show);
						m_timer_click_contextmenu_show = null;
					}
				})
				.on('touchstart touchmove touchend touchcancel', function(evt) {
					evt.preventDefault(); // Prevent text selection
				});
		}

		m_elem_media_result
			.selectable( Object.assign(
				{},
				common_selectable_options,
				{
					scrollEnabled: true,
					prepare: function( e, ui ) {
						var selectableItems = MVResult.getWidget().collectSelectableItems('prepare',m_scroll_borders);
						$(this).selectable('setSelectees',$(selectableItems));
					},
					scrolling: function( e, ui ) {
						var selectableItems = MVResult.getWidget().collectSelectableItems('scrolling',m_scroll_borders);
						$(this).selectable('setSelectees',$(selectableItems));
					},
				}
			) )
			.on( 'contextmenu', common_selectable_on_contextmenu_fn )
			.on( 'mousedown', function(evt) {

				// ignore this when on a button ..
				if( evt.which == 1 && elementHasOneOfClassNames(evt.target,['mmb']) ) {
					m_last_selectable_mousedown_on_elem_to_ignore = evt.target;
					return;
				}

				m_mediaCtxMenuWasVisibleOnInteractionStart = $('#media-ctx-menu').css('display') === 'block';
				m_mediaCtxMenuSelectedMediaIdsOnInteractionStart = m_sel_media_ids.slice();
				// console.log({w:'m_elem_media_result MOUSEDOWN ...', evt, evtWhich:evt.which, uiMediaResultSelLen:$('.ui-selected',m_elem_media_result).length, uiLightboxSelLen:$('.ui-selected',m_elem_media_lightbox_small).length });
				let target = $(evt.target);
				if( target.prop('id') == 'media-result' && target.hasClass('view-table') && evt.which == 1 && !( evt.ctrlKey || evt.shiftKey ) ) {
					// click in between thumbnails. deselect all assets
					if( m_lightbox_enabled ) m_elem_media_lightbox_small.find('.ui-selected').removeClass('ui-selected');
					m_elem_media_result.find('.ui-selected').removeClass('ui-selected');
					selection_changed(evt,false,'m_elem_media_result MOUSEDOWN');
				}
			})
			.on( 'mouseup', function(evt) {

				const tmp_elem = m_last_selectable_mousedown_on_elem_to_ignore;
				m_last_selectable_mousedown_on_elem_to_ignore = null;
				if( evt.which==1 && tmp_elem===evt.target ) {
					// ignore clicks on buttons ..
					return;
				}

				// console.log({w:'m_elem_media_result MOUSEUP ...', evt, evtWhich:evt.which, uiMediaResultSelLen:$('.ui-selected',m_elem_media_result).length, uiLightboxSelLen:$('.ui-selected',m_elem_media_lightbox_small).length });
				if( m_timer_click_contextmenu_show ) {
					clearTimeout(m_timer_click_contextmenu_show);
				}
				m_timer_click_contextmenu_show = setTimeout(function() {
					let newEvent = $.Event('contextmenu');
					newEvent.target = evt.target;
					newEvent.pageX = evt.pageX;
					newEvent.pageY = evt.pageY;
					newEvent.triggeredBy = 'm_elem_media_result mouseup';
					newEvent.triggeredByEvtType = evt.type;
					newEvent.triggeredByEvtWhich = evt.which ?? 1;
					newEvent.triggeredByEvtCtrlKey = evt.ctrlKey ?? false;
					if( m_lightbox_enabled ) {
						m_elem_media_lightbox_small.trigger(newEvent);
					}
					m_elem_media_result.trigger(newEvent);
				}, 250);
			})
			.on('dblclick', function(evt) {
				// console.log({w:'media-result dblclick ...',evt,selected:$('.ui-selected',m_elem_media_result).length});
				if( m_timer_click_contextmenu_show ) {
					clearTimeout(m_timer_click_contextmenu_show);
					m_timer_click_contextmenu_show = null;
				}
			})
			.on('touchstart touchmove touchend touchcancel', function(evt) {
				evt.preventDefault(); // Prevent text selection
			});

		//========================================================================================================
		// initMVMediaPageActions
		//========================================================================================================

		initMVMediaPageActions(
			function() {
				selection_changed(null,false,'initMVMediaPageActions');
			}
		);


		//========================================================================================================
		// setup MVResult view on #media-result
		//========================================================================================================

		MVResult.init(
			'mt',
			m_elem_media_result,
			function _list_changed( evt, list_data_obj ) {
				const list_type = list_data_obj.getState().list_type;
				var search_info_obj = null;
				if( list_type==='search' || list_type==='slist' ) {
					search_info_obj = MVSearch.getSearchRequest();
					$('#mhr').removeClass('disabled');
				} else if( list_type==='lightbox' ) {
					// disable ranking/sorting when showing a lightbox
					$('#mhr').addClass('disabled');
				}
				mr_info.mjMediaResultInfoWidget('updateResultInfo',list_data_obj,search_info_obj);
			},
			selection_changed,
			function _second_click_on_thumbnail( evt ) {
				// plain click on already selected media node -> hide or re-activate "context toolbar"
				return true;
			},
			function _clear_external_selections( evt ) {
				if( m_lightbox_enabled ) {
					// clear any external selections: in this case, the lightbox:
					$('#lb-result > .lb-item.ui-selected').removeClass('ui-selected');
				}
			},
			function _view_type_changed( evt, type ) {
				// update button states
				$('#mhv-table').toggleClass('active',type==='table');
				$('#mhv-list').toggleClass('active',type==='list');
				$('#mhv-grid').toggleClass('active',type==='grid');
			},
			MVDetail.open,
			function _result_nodes_loaded( evt, data ) {
				// console.log({w:'_result_nodes_loaded',data});
				const cb = m_runOnceOnResultNodesLoaded;
				if( cb!==null ) {
					m_runOnceOnResultNodesLoaded = null;
					cb(data);
				}
			},
			m_lightbox_enabled
		);

		//========================================================================================================
		// setup MVPreview view on #media-preview
		//========================================================================================================

		var mp = $('#media-preview');
		var mp_band = $('#media-preview-band');
		MVPreview.init( mp, MVDetail.open );

		//========================================================================================================
		// setup preview and splitter between #media-result & #media-preview
		//========================================================================================================

		mp_band.on( 'contextmenu', function() {
			return false;
		} );
		mp_band[0].onselectstart = function() {
			return false;
		};

		// TODO: move most of this code to mj.preview.js !

		function mp_closed_or_hidden( mp_band ) {
			return elementHasOneOfClassNames(mp_band[0],['closed','hidden']);
		}

		var cfg_pr_min_w = 200;		// minimum width of result view (if smaller, then preview panel will not be available)
		var cfg_mp_min_w = 300;		// minimum width of preview panel (will collapse to closed state for any width below this value)
		var cfg_mp_max_w = 2400;
		var cfg_mp_band_w = mp_band.width()||0;
		var cfg_mp_cur_w = getFromSession('media_preview_opened')=='1' ? parseInt(getFromSession('media_preview_width',mp.width()||0),10) : 0;
		function mp_on_stop( mp ) {
			var mp_closed = mp_closed_or_hidden(mp_band);
			var mp_w = mp_closed ? 0 : mp.width()||0;
			// update view
			if( !mp_closed ) MVPreview.onResize(true,true);
			// save width in session
			if( mp_w != cfg_mp_cur_w ) {
				cfg_mp_cur_w = mp_w;
				var session_data_2update = {'media_preview_opened':mp_closed?'0':'1'};
				if( !mp_closed ) session_data_2update.media_preview_width = mp_w;
				setInSession(session_data_2update);
			}
		}
		function mp_on_resize( mp ) {
			var mp_w = mp.width()||0;
			var do_hide = false;
			var do_resize = false;
			if( mp_w < cfg_mp_min_w ) {
				mp_w = 0;
				mp.css('width',mp_w+'px');
				if( !mp_closed_or_hidden(mp_band) ) { // avoid multiple calls
					do_hide = true;
					mp.resizable('disable');
					mp_band.addClass('closed');
				}
			} else {
				do_resize = true;
				var pr_w = pr.width()||0;
				if( mp_w > pr_w-cfg_pr_min_w ) {
					mp_w = pr_w-cfg_pr_min_w;
					mp.css('width',mp_w+'px');
				}
				mp_band.filter('.closed').removeClass('closed');
				mp.resizable('enable');
			}
			// move #media-result, #media-result-info & #media-preview-band
			var mp_band_visible = mp_band.is(':visible');
			var mri_right_1 = mp_band_visible ? (mp_w) : 0;
			var mri_right_2 = mp_band_visible ? (mp_w+cfg_mp_band_w) : 0;
			mr_info.css({right:mri_right_1+'px'});
			m_elem_media_result.css({right:mri_right_2+'px'});
			mp_band.css({right:mp_w+'px'});
			// remove height & left styles (was added by "ui resizable", but leads to problems)
			mp.css({height:'',left:''});
			// update view...
			if( do_hide ) MVPreview.onHide();
			else if( do_resize && !mp_closed_or_hidden(mp_band) ) MVPreview.onResize(false,false);
		}

		function mp_on_winresize( stop ) {
			if( (pr.width()||0) < cfg_mp_min_w+cfg_pr_min_w+cfg_mp_band_w ) {
				// hide preview, when space is not sufficient
				MVPreview.onHide();
				mp.hide();
				mp_band.addClass('hidden');
				mr_and_mr_info.css('right','0px');
			} else {
				mp.show();
				mp_band.removeClass('hidden');
				mp_on_resize(mp);
			}
			if( stop ) mp_on_stop(mp);
		}

		// setup ...
		$(document).on( 'mjswinresize', $.debounce( 250, function() {
			mp_on_winresize(true);
		} ) );

		var mp_last_resizable_stop_ts = null;
		mp.resizable( {
			handles:	'w',
			minWidth:	cfg_mp_min_w-1,
			maxWidth:	cfg_mp_max_w,
			start:		function(evt,ui) {
			},
			resize:		function(evt,ui) {
				mp_on_resize($(this));
			},
			stop:		function(evt,ui) {
				mp_last_resizable_stop_ts = evt.timeStamp;
				mp_on_stop($(this));
			},
		} );
		mp.children('.ui-resizable-handle.ui-resizable-w').on('click',function(e) {
			if( e.timeStamp - (mp_last_resizable_stop_ts||0) > 200 ) {
				mp_band.triggerHandler('click');
				return false;
			}
		});
		mp_band.click( function(e) {
			var trg_w=0;
			if( elementHasClassName(this,'closed') ) {
				// open
				trg_w = parseInt(getFromSession('media_preview_width',0),10); // get value from session
				if( trg_w < cfg_mp_min_w ) trg_w = 0.5 * ( cfg_mp_min_w + 0.5*(pr.width()||0) ); // or default to a golden section
				if( trg_w < cfg_mp_min_w ) trg_w = cfg_mp_min_w; // but at least this width
			} else {
				// close
				trg_w = cfg_mp_min_w-1;
			}
			mp.css('width',trg_w+'px');
			mp_on_resize(mp);
			mp_on_stop(mp);
		} );

		// init ...
		mr_and_mr_info.css('right',(cfg_mp_cur_w+cfg_mp_band_w)+'px');
		mp_band.css('right',cfg_mp_cur_w+'px');
		mp.css('width',cfg_mp_cur_w+'px');
		mp_on_winresize(true);

		//========================================================================================================
		// setup result view header controls
		//========================================================================================================

		// view_size slider
		var mhs_slider = $('#media-header-size .slider');
		mhs_slider.slider( {
			value: getFromSession('view_size'),
			min:3, max:32,
			orientation:'horizontal',
			animate:'fast',
			slide:function(e,ui) {
				if( MVResult.getVisibleResultsCount() <= 200 ) {
					var val = ui.value || $(this).slider('value');
					MVResult.setViewSize(val,false);
				}
			},
			change:function(e,ui) {
				var val = ui.value || $(this).slider('value');
				MVResult.setViewSize(val,true);
				e.preventDefault();
			},
		} );
		$('#media-header-size .slider-icon1').click( function(e) {
			mhs_slider.slider('value',mhs_slider.slider('value')-3);
			e.preventDefault();
		} );
		$('#media-header-size .slider-icon2').click( function(e) {
			mhs_slider.slider('value',mhs_slider.slider('value')+3);
			e.preventDefault();
		} );

		// view type switch
		$('#mhv-table').click( function(e) {
			MVResult.setViewType('table',true);
			e.preventDefault();
		} );
		$('#mhv-grid').click( function(e) {
			MVResult.setViewType('grid',true);
			e.preventDefault();
		} );
		$('#mhv-list').click( function(e) {
			MVResult.setViewType('list',true);
			e.preventDefault();
		} );

		// sort/ranking selector
		$('#mhr').click( function(e) {
			if( !elementHasClassName(e.target,'disabled') ) {
				MVSortOptions.open();
			}
			e.preventDefault();
		} );

		// initialize view type & size
		var mvrvt = getFromSession('view_type');
		MVResult.setViewType( mvrvt, false );

		//========================================================================================================
		// setup result view toolbar
		//========================================================================================================

		$('#tb-upload-i,#tb-upload-t').click(		function(e) {
			if( window.MVUpload ) window.MVUpload.open();
			e.preventDefault();
		} );
		$('#tb-open-i,#tb-open-t').click(			function(e) {
			media_action('open');
			e.preventDefault();
		} );
		$('#tb-lbin-i,#tb-lbin-t').click(			function(e) {
			media_action('lb-in');
			e.preventDefault();
		} );
		$('#tb-lbout-i,#tb-lbout-t').click(			function(e) {
			media_action('lb-out');
			e.preventDefault();
		} );
		$('#tb-download-i,#tb-download-t').click(	function(e) {
			media_action('download');
			e.preventDefault();
		} );
		$('#tb-send-i,#tb-send-t').click(			function(e) {
			media_action('send');
			e.preventDefault();
		} );
		$('#tb-publish-i,#tb-publish-t').click(		function(e) {
			media_action('publish');
			e.preventDefault();
		} );
		$('#tb-export-i,#tb-export-t').click(		function(e) {
			media_action('export');
			e.preventDefault();
		} );
		$('#tb-print-i,#tb-print-t').click(			function(e) {
			media_action('print');
			e.preventDefault();
		} );
		$('#tb-delete-i,#tb-delete-t').click(		function(e) {
			media_action('delete');
			e.preventDefault();
		} );
		$('#media-toolbar td.text > a').on( 'mouseover mouseout', function( e ) {
			var id = this.id;
			$( '#'+id.substr(0,id.length-2)+'-i' )
				.not('.disabled')
				.toggleClass( 'hover', e.type==='mouseover' );
		} );

		//========================================================================================================
		// setup request options handlers
		//========================================================================================================

		function _default_result_view_init() {
			// init result view with configured defaults
			if( (mj.search.default_search_string||mj.search.default_categories.length) && !Lightbox.isValidLightboxId(mj.lightbox.lb_id_requested) ) {
				var dss = mj.search.default_search_string;
				if( mj.search.default_categories.length ) {
					MVSearch.triggerSearchByCategories(dss?dss:'*',mj.search.default_categories,true);
				} else {
					MVSearch.triggerSearchByTag(dss,true);
				}
			} else {
				MVSearch.triggerReset(true);
			}
		}

		function _media_hashchange_handler(k,v,t) {
			var j;
			MVDetail.hide();
			focus_category_for_ctx_menu(null,null);
			if( k===null ) {
				// init view from configured defaults
				_default_result_view_init();
			} else if( k==='sr' ) {
				// init view from search request
				if( v==='' || v==='null' ) {
					MVSearch.doReset();
				} else {
					var sr = null;
					try {
						sr = unserializeSearchRequest(v);
					} catch( err ) {
						sr = createSearchRequest({});
					}
					var sro = sr.normalized().withCategoriesInflated();
					//console.log( ['_media_hashchange_handler CALLING MVSearch.doTriggerSearchByRequestObject',sro,v,t] );
					MVSearch.doTriggerSearchByRequestObject(sro,null,true,false,false);
				}
			} else if( k==='search' ) {
				// init view from search request (fulltext string only)
				MVSearch.triggerSearchByTag(v);
			} else if( k==='category' ) {
				// init view from show-category request
				j = JSON.parse(v);
				if( typeof j === 'string' || typeof j === 'number' ) MVSearch.triggerSearchByCategory(null,j,true);
				else MVSearch.triggerSearchByCategory(j[0],j[1],true);
			} else if( k==='category-focus' ) {
				// init view from category-focus request
				j = JSON.parse(v);
				const treeAndCatId = typeof j === 'string' || typeof j === 'number'
					? [MDTrees.getTreeIdFromCategoryId(j),j]
					: [j[0],j[1]];
				const parentCatId = MDTrees.getParentIdFromCategoryId(treeAndCatId[1]);
				// search for parent category ...
				MVSearch.triggerSearchByCategory(
					treeAndCatId[0],
					parentCatId,
					true,
					'browse',
					function() {
						// .. and select the requested category:
						const rv_widget = MVResult.getWidget();
						rv_widget.updateSelectedNodes( 0, 0, function() {
							// quick hack..
							focus_category_for_ctx_menu(treeAndCatId[0],treeAndCatId[1]);
							// $('#cat-node-'+treeAndCatId[0]+'-'+treeAndCatId[1]).addClass('ui-dynatree-focused');

							MVResult.getWidget().selectVisibleCategoryNode(treeAndCatId[0],treeAndCatId[1],true);
						} );
					}
				);
			} else if( k==='details' ) {
				j = JSON.parse(v);
				if( typeof j === 'string' || typeof j === 'number' ) {
					// init view from configured defaults
					_default_result_view_init();
					// and show requested details in detail-view overlay
					MVDetail.open([j],'detail',0);
				} else if( typeof j === 'object' ) {
					// ie: https://localhost:32770/manja/media/#details={"media_ids"%3A["303499","140784","131257","131250"]%2C"tree_id"%3A1%2C"cat_id"%3A"7294"}
					const select_media_ids = j.media_ids ?? [];
					let already_selected_media_ids = [];
					const runOnceOnResultNodesLoader = function( data ) {
						// console.log({w:'runOnceOnResultNodesLoader',select_media_ids,already_selected_media_ids,data_media_ids:data.media_ids??[]});
						for( let media_id of data.media_ids ?? [] ) {
							if( select_media_ids.indexOf(media_id)!==-1 ) already_selected_media_ids.push(media_id);
						}
						if( already_selected_media_ids.length < select_media_ids.length ) m_runOnceOnResultNodesLoaded = runOnceOnResultNodesLoader;
						MVResult.selectVisibleNodes(already_selected_media_ids,true,true);
					};
					const categories_done_cb = function() {
						m_runOnceOnResultNodesLoaded = runOnceOnResultNodesLoader;
						requestAnimationFrame( function() {
							MVDetail.open(select_media_ids,'detail',j.index);
						} );
					};
					const category_id = j.category_id || j.cat_id || null;
					if( category_id ) {
						// init view for category ..
						// .. and show requested details in detail-view overlay
						const tree_id = j.tree_id || null;
						MVSearch.triggerSearchByCategory(tree_id,category_id,true,false,categories_done_cb);
					} else {
						// init view from configured defaults
						_default_result_view_init();
						// .. and show requested details in detail-view overlay
						categories_done_cb();
					}
				}
			} else if( k==='details2' ) {
				if( v!=='' && v!=='null' ) {
					var details2 = JSON.parse(v);
					MVDetail.open2(details2);
				}
			} else if( k==='slist' ) {
				// init view from show-category request
				j = JSON.parse(v);
				if( typeof j === 'string' || typeof j === 'number' ) {
					MVResult.loadSearchList(j);
				}
			} else if( k==='lightbox' ) {
				if( m_lightbox_enabled ) {
					Lightbox.change(parseInt(v,10),true,false,function() {
						Lightbox.go();
					},function() {
						// invalid lightbox
					});
				}
			} else if( k==='srd2' ) {
				// init view from search request + details
				if( v==='' || v==='null' ) {
					MVSearch.doReset();
				} else {
					var parts = JSON.parse(v);
					if( parts.hasOwnProperty('sr') ) {
						_media_hashchange_handler('sr',parts.sr,t);
					}
					if( parts.hasOwnProperty('details2') ) {
						_media_hashchange_handler('details2',parts.details2,t);
					}
				}
			}
			// TODO: include dialogs (e.g. detail view) in location hash:
			//   - but then MVPageHistory.go() & current mjshashchange event will not be sufficient,
			//   - there will have to be some kind of "page key" (as above) plus a "dialog key",
			//     and some logic to open/close dialogs based on that key,
			//     and logic to check whether "page key" encodes current state or not
			//
			// maybe BBQ plugin provides all required functionality?
			//	-> http://benalman.com/projects/jquery-bbq-plugin/
			//     ...
		}

		var _media_previous_hashchange = null;//[null,null];
		$(document).on( 'mjshashchange', function _mjshashchange_handler1(e,k,v,t) {
			var was_not_null = _media_previous_hashchange!==null;
			_media_previous_hashchange = [k,v,t];
			if( was_not_null ) _media_hashchange_handler(k,v,t);
		} );

		//========================================================================================================
		// setup search view
		//========================================================================================================

		var result_view_widget = MVResult.getWidget();

		MVSearch.init(
			$('#search-form'),
			mj.search,
			function media_search_default_trigger_cb( trigger, interact_with_history ) {
				//console.log(['media_search_default_trigger_cb', trigger, interact_with_history ]);
				if( _media_previous_hashchange===null ) _media_previous_hashchange = [null,null,null];
				if( trigger || interact_with_history ) _media_hashchange_handler(_media_previous_hashchange[0],_media_previous_hashchange[1]);
			},
			result_view_widget
		);

		//========================================================================================================
		// setup mini lightbox
		//========================================================================================================

		if( m_lightbox_enabled ) {
			// mini lightbox initialization
			const lb_id_current = parseInt(getFromSession('lightbox_id','0'),10);
			const lb_small_open = getFromSession('lightbox_small_opened','0')==='1';
			Lightbox.init(
				lb_id_current,
				lb_small_open,
				mj.lightbox.lb_id_requested,
				selection_changed,
				!!mj.lightbox.single_lb,
				function _dblclick_action() {
					media_action('open');
				},
				MVDetail.open,
				result_view_widget,
				mr_info,
				$([mp[0],mp_band[0]])
			);

		} else {
			Lightbox.initDisabled(
				result_view_widget,
				mr_info,
				$([mp[0],mp_band[0]])
			);
		}


		//========================================================================================================
		// setup keyboard controller
		//========================================================================================================
		MMediaViewsKbdCtrl.init(
			m_elem_media_result,
			result_view_widget,
			function _open_action() {
				media_action('open');
			},
			null
		);

		//========================================================================================================
		// setup collections
		//========================================================================================================
		MVCollections.updateCollections();

		//========================================================================================================
		// setup collections
		//========================================================================================================
		if( mj.role_manager ) {
			if( window.MVUpload ) window.MVUpload.init();
		}

		//========================================================================================================
		// setup other
		//========================================================================================================

		$('#search-string').select();

		// animate the upload button
		$('#tb-upload-i').animate( {opacity:'1'}, 'slow', 'swing', function() {
			$(this).animate( {opacity:'0.1'}, 'fast', 'linear', function() {
				$(this).animate( {opacity:'1'}, 'fast', 'swing' );
			} );
		} );
	}

	return {
		init,
		media_action,

		contextMenuDynamicContent: function(content) {
			// console.log({w:'contextMenuDynamicContent',content,curMenuHandle:m_media_ctx_menu_options.cur_menu_handle});
			if(content !== m_media_ctx_menu_options.dynamic) m_media_ctx_menu_options.reset = true;
			m_media_ctx_menu_options.dynamic = content;
			// menu was probl. already displayed before dynamic content was added -> redraw menu
			if(content !== null && m_media_ctx_menu_options.cur_menu_handle !== null) {
				m_media_ctx_menu_options.cur_menu_handle.updateContent(content);
			}
		},

		selection_changed,
		// getSelection,

		start_search,
		start_search_categories,
		focus_category_for_ctx_menu,
	};

}(jQuery,mj); // namespace MVMediaPage


// support for onclick="MVMediaPage.start_search(..)",
window.MVMediaPage = MVMediaPage;
